import React, { PureComponent } from 'react';
import { string, number } from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import ServiceAdherenceDetail from '../../../ServiceAdherenceDetail';
import { accountPropTypes } from '../../../../../redux/accountHandlers';

import styles from './styles';

class ServiceAdherenceField extends PureComponent {
  render() {
    const chosenStyle = this.props.index % 2 ? styles.evenRow : styles.oddRow;
    return (
      <div style={chosenStyle}>
        <UTLabel small bold>
          {this.props.field}
        </UTLabel>
        <ServiceAdherenceDetail
          adherence={this.props.value}
          formId={this.props.formId}
          account={this.props.account}
          service={this.props.service}
        />
      </div>
    );
  }
}

ServiceAdherenceField.propTypes = {
  field: string.isRequired,
  value: string.isRequired,
  index: number.isRequired,
  formId: number.isRequired,
  account: accountPropTypes,
  service: string.isRequired
};

export default ServiceAdherenceField;
